









































import { Component, Vue } from "vue-property-decorator";
import Bot from "@/store/entities/flight/bot";
import { VBreadcrumbs, VIcon, VCard, VCardTitle, VCardText, VRow, VCol, VCheckbox, VCardActions, VBtn } from "vuetify/lib";
@Component({})
export default class Xml extends Vue {
  breadcrumbsItems: any[] = [];
  auxServices: Bot[] = [];

  async created() {
     await this.getBotStatuses();
     this.auxServices = this.$store.state.bot.list;
    console.log(this.auxServices)
    this.breadcrumbsItems = [
      { text: "Ana Sayfa", disabled: false, href: "/#/main/home" },
      { text: "Uçuş", disabled: true },
      { text: "XML", disabled: true },
    ];
  }

      async getBotStatuses() {
    await this.$store.dispatch({
      type: "bot/getBotStatuses"
    });
      }

  async saveXml() {
    await this.$store.dispatch({
      type: "bot/setBotStatuses", data: this.auxServices,
    }).then(x=>{
      Vue.$toast.success("Kayıtlar Güncellendi");
    });
      

    
  }
  

  data() {
    return {};
  }
}
